;
function init() {
    initInfoWarnings();
}

window.initInfoWarnings = () => {
    if (!$(".edit-warnings").length) {
        return;
    }
    var dlg_warn = $("#stationWarnings").dialog({
        autoOpen: false,
        modal: true,
        width: 640,
        title: "Informative Warnwerte",
        height: 540,
        maxHeight: 540
    });

    $('.edit-warnings i').click(function(event) {
        edit_warnings(this, event);
    });
    function edit_warnings(el, event) {
        el = $(el);
        var url = '/Handler/HvD/Warnings';
        if (el.attr('data-url')) {
            url = el.attr('data-url');
        }
        dlg_warn.stationType = el.attr('data-type');
        dlg_warn.stationId = el.attr('data-id');
        dlg_warn.find('.cancel').click(function(event) {
            dlg_warn.dialog("close");
            $('.warn-inner').html('');
        });

        $('.warn-inner').html('');
        $(el).show();
        $.ajax({
            cache: false,
            type: "POST",
            url: url,
            data: {
                data: {
                    action: 'read',
                    stationId: dlg_warn.stationId,
                    stationType: dlg_warn.stationType
                }
            }
        }).done(function(data) {
            data = JSON.parse(data);

            var $template = dlg_warn.find('.warn-item');
            var drpParameter = $template.find('.drp-parameter');
            drpParameter.html('');
            window.debug = drpParameter;
            $.each(data.parameter, function(key, value) {
                drpParameter.append($('<option value="' + this.id + '" data-unit="' + this.unit + '">' + this.name + '</option>'));
            });
            $('.drp-parameter').off();
            $('.drp-parameter').change(drpParameterChange);
            dlg_warn.find('.add').off();
            dlg_warn.find('.remove').off();
            dlg_warn.find('.add').click(add);
            for (var i = 0; i < data.items.length; i++) {
                var item = add();
                var itemData = data.items[i];
                item.find('.valueData').val(itemData.value);
                item.find('.paraData').val(itemData.parameterId);
                item.find('.unitData').val(itemData.unit);
                item.find('.labelData').val(itemData.label);
            }

            function add(event) {
                var i = $('.warn-inner').find('.warn-item').length;
                var item2add = $($template).clone();
                item2add.show();
                item2add.find('.labelData').attr('data-index', i)[0];
                item2add.find('.valueData').attr('data-index', i)[0];
                item2add.find('.paraData').attr('data-index', i)[0];
                item2add.find('.unitData').attr('data-index', i)[0];
                item2add.find('.unitData').val(item2add.find('.paraData').val());
                $('.warn-inner').append(item2add);
                item2add.find('.remove').click(function(event) {
                    $(event.currentTarget).closest('.warn-item').remove();
                    $(dlg_warn).find('.warn-inner .warn-item').each(function(i, el) {
                        el = $(el);
                        el.find('.labelData').attr('data-index', i)[0];
                        el.find('.valueData').attr('data-index', i)[0];
                        el.find('.paraData').attr('data-index', i)[0];
                        el.find('.unitData').attr('data-index', i)[0];
                    });
                });
                $('.drp-parameter').off();
                $('.drp-parameter').change(drpParameterChange);
                return item2add;
            }


            function drpParameterChange(event) {
                $(this).next().val($(this).val());
            }
            $template.hide();
            dlg_warn.dialog("open");
            /* Speichern */
            if (!dlg_warn.saveStationlData) {
                dlg_warn.saveStationlData = dlg_warn.find('.ok').click(function(event) {
                    var $data = dlg_warn.find('.warn-inner input, .warn-inner select');
                    var data = [];
                    console.debug($data);
                    $data.each(function(i, el) {
                        if (!data[$(el).attr('data-index')]) {
                            data[$(el).attr('data-index')] = {};
                        }
                        data[$(el).attr('data-index')][el.name] = $(el).val();
                    });
                    console.debug(data);;
                    $.ajax({
                        cache: false,
                        type: "POST",
                        url: url,
                        data: {
                            'data': {
                                action: 'update',
                                stationId: dlg_warn.stationId,
                                stationType: dlg_warn.stationType,
                                data: data
                            }
                        }
                    }).done(function(data) {
                        if (data === 'ok') {
                            tools.toast('Warnwerte', 'Informativen Warnwerte wurden gespeichert');
                        } else {
                            tools.toast('Warnwerte', 'Beim speichern ist ein Fehler aufgetreten');
                        }
                    });

                    //dlg_warn.dialog("close");
                });
            }


        });
    }
}
window.setTimeout(init, 200);
